import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  constructor(public authService:AuthService) { }

  ngOnInit() {
  }
  onSubmit(form:NgForm){
    const email = form.value.email
    const password = form.value.password
    // this.authService.singupUser(email,password)
  }

}
